export default "__VITE_ASSET__CYhvzw6T__"